/**
 * External Dependencies
 */

import Vue from 'vue';
import MenuItem from '../components/MenuItem';
import ImageSlider from '../components/ImageSlider';
import MultiSlider from '../components/MultiSlider';

var app = new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    components: {
      'menu-item': MenuItem,
      'image-slider': ImageSlider,
      'multi-slider': MultiSlider,
    },
    data: {
      navOpen: false,
      searchOpen: false,
      gridLayout: true,
    },
    methods: {
      toggleNavigation: function () {
        this.navOpen = !this.navOpen;
      },
      productsChangeLayout: function () {
        this.gridLayout = !this.gridLayout;
      }
    }
  })
  